<template>
  <Layout>
    <GoBack text="shottracker news" link="Media" />
    <Title class="my-4" text="Edit Press Release" />
    <LoadingSpinner v-if="loading.display" :message="loading.message" />
    <div v-else>
      <PressReleaseForm
        v-if="!isFileEmpty"
        :form="file.JSON"
        :imageUploaded="file.imageURL"
        @handleSubmit="handleSubmit"
        :editMode="true"
        @getFile="getFile"
      />
    </div>
  </Layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Title from "../Title.vue";
import Layout from "../../Layout";
import PressReleaseForm from "./PressReleaseForm.vue";
import LoadingSpinner from "../../LoadingSpinner";
import GoBack from "../../GoBack.vue";
import loader from "../../../mixins/loader";
import initData from "../../../mixins/initData";

export default {
  name: "EditPressRelease",
  mixins: [initData, loader],

  components: {
    PressReleaseForm,
    Title,
    LoadingSpinner,
    Layout,
    GoBack,
  },

  data() {
    return {
      header: "",
      subheader: "",
      homeFeatured: false,
      featured: false,
      date: "",
    };
  },

  computed: {
    ...mapGetters(["file", "directory", "pressReleasesID"]),

    isFileEmpty() {
      return Object.keys(this.file).length === 0;
    },

    noPressReleases() {
      return this.directory.pressReleases.length === 0;
    },
  },

  methods: {
    ...mapActions(["updateFileInS3", "fetchFile", "updateDirectory"]),

    getFile(files) {
      this.file.JSON.file = files.length === 1 ? files[0] : "";
    },

    async handleSubmit() {
      const newHeader = this.file.JSON.header;
      const newSubheader = this.file.JSON.subheader;
      const newHomeFeatured = this.file.JSON.homeFeatured;
      const newDate = this.file.JSON.date;
      const newFeatured = this.file.JSON.featured;

      const updateDirectory =
        this.header !== newHeader ||
        this.date !== newDate ||
        this.featured !== newFeatured ||
        this.subheader !== newSubheader ||
        this.homeFeatured !== newHomeFeatured;

      let updatedIndex = null;

      if (updateDirectory) {
        updatedIndex = {
          header: newHeader,
          subheader: newSubheader,
          date: newDate,
          homeFeatured: newHomeFeatured,
          featured: newFeatured,
          id: this.file.identifier,
        };
      }

      const file = this.file;
      const { directoryKey } = this.pressReleasesID;
      const newFile = { file, updatedIndex, directoryKey };
      await this.load(this.updateFileInS3(newFile), "Updating press release");

      this.$router.push({
        name: "PressReleasePage",
        params: { id: this.file.identifier },
      });
    },
  },

  async created() {
    const identifier = this.$route.params.id;

    if (this.noPressReleases) {
      await this.load(
        this.initData(this.pressReleasesID),
        "Loading press release"
      );
    }

    await this.load(this.fetchFile(identifier), "Loading press release");

    this.header = this.file.JSON.header;
    this.subheader = this.file.JSON.subheader;
    this.homeFeatured = this.file.JSON.homeFeatured;
    this.featured = this.file.JSON.featured;
    this.date = this.file.JSON.date;
  },
};
</script>